import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../../../../../sub-modules/SharedModule';
import { ActionCellComponent } from './renderer/action/action-cell.component';
import { UserCellComponent } from './renderer/user/user-cell.component';
import { DecisionMakerCellComponent } from './renderer/decision-maker/decision-maker-cell.component';
import { TransferWorkspaceProjectsRightsCellComponent } from './renderer/transfer/transfer-project-rights-cell.component';
import { EmailCellComponent } from './renderer/email/email-cell.component';
import { WorkspaceProjectPermissionTableHeader } from './header/workspace-project-permission-table-header.component';

@NgModule({
  declarations: [
    ActionCellComponent,
    UserCellComponent,
    DecisionMakerCellComponent,
    EmailCellComponent,
    WorkspaceProjectPermissionTableHeader,
    TransferWorkspaceProjectsRightsCellComponent,
  ],
  imports: [CommonModule, FormsModule, SharedModule],
  exports: [
    ActionCellComponent,
    UserCellComponent,
    DecisionMakerCellComponent,
    EmailCellComponent,
    WorkspaceProjectPermissionTableHeader,
    TransferWorkspaceProjectsRightsCellComponent,
  ],
})
export class WorkspaceProjectParticipantTableModule {}
